var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankStatement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.0237V10.562C5 10.2875 5.22386 10.0001 5.5 10.0001H9.5C9.77614 10.0001 10 10.2875 10 10.562V17.0237M14 17.0237V10.562C14 10.2875 14.2239 10.0001 14.5 10.0001H18.5C18.7761 10.0001 19 10.2875 19 10.562V17.0237M21 7.51168V9.47268C21 9.71629 20.7761 10.0001 20.5 10.0001H3.5C3.22386 10.0001 3 9.71629 3 9.47268V7.51168C3 7.35959 3.08881 7.21824 3.235 7.13763L11.735 3.00236C11.8971 2.91296 12.1029 2.91296 12.265 3.00236L20.765 7.13763C20.9112 7.21824 21 7.35959 21 7.51168ZM3.5 21.0001H20.5C20.7761 21.0001 21 20.7776 21 20.5031V17.5207C21 17.2462 20.7761 17.0237 20.5 17.0237H3.5C3.22386 17.0237 3 17.2462 3 17.5207V20.5031C3 20.7776 3.22386 21.0001 3.5 21.0001Z",
    stroke: "#8F27C7",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankStatement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bank-statement.525ea23fe898ec71c1133395df52c8bf.svg";